import React from 'react';
import { Icon, Header, Segment, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { SymbolIndicatorEnum } from 'PointOfSale/modules/common/constants';
// import { getIconAndColor } from 'PointOfSale/modules/common/helpers';

import 'PointOfSale/styles/components/symbolIndicator.less';

const formatMessage = message => {
  if (message.length > 1) {
    return message.substring(message.indexOf(':') + 1, message.length);
  }
};

const MessageContainer = ({ symbolIndicator }) => {
  if (!symbolIndicator || symbolIndicator === undefined) {
    return null;
  }

  const allergens = symbolIndicator.find(
    x => x.type === SymbolIndicatorEnum.Allergen
  );
  // const allergenIcon = getIconAndColor(allergens);

  const specialMessage = symbolIndicator.find(
    x => x.type === SymbolIndicatorEnum.SpecialMessage
  );
  // const specialMessageIcon = getIconAndColor(specialMessage);

  return (
    <React.Fragment>
      <Grid.Row className="allergens-message-container">
        <Grid.Column width="7" stretched className="pad-slim-right">
          <Segment color="red">
            <Header as="h4">
              <Header.Content>
                <Icon name="warning sign" color="red" /> Allergens
                <Header.Subheader>
                  {allergens && formatMessage(allergens.message)}
                </Header.Subheader>
              </Header.Content>
            </Header>
          </Segment>
        </Grid.Column>
        <Grid.Column width="9" stretched className="pad-slim-left">
          <Segment color="green">
            <Header as="h4">
              <Header.Content>
                <Icon name="talk" color="green" /> Special Message
                <Header.Subheader>
                  {specialMessage && formatMessage(specialMessage.message)}
                </Header.Subheader>
              </Header.Content>
            </Header>
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </React.Fragment>
  );
};

MessageContainer.propTypes = {
  symbolIndicator: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      message: PropTypes.string,
      className: PropTypes.string,
    })
  ),
};

export default MessageContainer;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/component/MessageContainer.js